import i18n from "../i18n";

// RillFetcher resolves on HTTP errors; surface the API's message instead.
const assertOk = async (res) => {
  if (res.ok) return;
  const body = await res.json().catch(() => ({}));
  throw new Error(body.message || body.error || res.statusText);
};

const ChallengeReportTemplates = (app) => {
  app
    // Create or update a template (PUT not supported in Rill; pass id in body to update)
    .post("/challenge-report-templates", async ({ req, res, flash, api }) => {
      const { id, ...body } = req.body;
      try {
        if (id) {
          await api(`challenge-report-templates/${id}`, {
            method: "PUT",
            body,
          });
          flash(
            "success",
            i18n.t(
              "coaching-portal:challengeReportTemplates.updatedSuccessfully",
              "Template updated successfully"
            )
          );
        } else {
          await api("challenge-report-templates", {
            method: "POST",
            body,
          });
          flash(
            "success",
            i18n.t(
              "coaching-portal:challengeReportTemplates.savedSuccessfully",
              "Template saved successfully"
            )
          );
        }
      } catch (e) {
        flash("error", e.message);
      }
      res.backDontScroll();
    })
    // Delete a template
    .post(
      "/challenge-report-templates/remove",
      async ({ req, res, flash, api }) => {
        const { id } = req.body;
        try {
          await api(`challenge-report-templates/${id}`, {
            method: "DELETE",
          });
          flash(
            "success",
            i18n.t(
              "coaching-portal:challengeReportTemplates.deletedSuccessfully",
              "Template deleted successfully"
            )
          );
        } catch (e) {
          flash("error", e.message);
        }
        res.backDontScroll();
      }
    )
    // Member leaderboards: publish (or replace) a board for an audience
    .post("/leaderboard-boards", async ({ req, res, flash, api }) => {
      try {
        await assertOk(
          await api("leaderboard-boards", { method: "POST", body: req.body })
        );
        flash(
          "success",
          i18n.t(
            "coaching-portal:challengeReport.publish.published",
            "Leaderboard published"
          )
        );
      } catch (e) {
        flash("error", e.message);
      }
      res.backDontScroll();
    })
    // Rename / turn off / turn on
    .post("/leaderboard-boards/update", async ({ req, res, flash, api }) => {
      const { id, ...body } = req.body;
      try {
        await assertOk(
          await api(`leaderboard-boards/${id}`, { method: "PUT", body })
        );
      } catch (e) {
        flash("error", e.message);
      }
      res.backDontScroll();
    })
    .post("/leaderboard-boards/remove", async ({ req, res, flash, api }) => {
      try {
        await assertOk(
          await api(`leaderboard-boards/${req.body.id}`, { method: "DELETE" })
        );
      } catch (e) {
        flash("error", e.message);
      }
      res.backDontScroll();
    })
    // Put a member on hold (off every leaderboard of the audience's owner),
    // edit the hold's note, or return them to the board
    .post("/leaderboard-holds", async ({ req, res, flash, api }) => {
      const { userId, audience, restore, name, why, note } = req.body;
      try {
        await assertOk(
          await api(`leaderboard-holds/${userId}`, {
            method: restore ? "DELETE" : "PUT",
            query: { audience },
            ...(!restore && {
              body: {
                ...(why != null && { why: String(why) }),
                ...(note != null && { note: String(note) }),
              },
            }),
          })
        );
        if (name != null) {
          flash(
            "success",
            restore
              ? i18n.t(
                  "coaching-portal:challengeReport.hold.returned",
                  "{{name}} is back on the board.",
                  { name }
                )
              : i18n.t(
                  "coaching-portal:challengeReport.hold.putOnHoldDone",
                  "{{name}} is on hold — off the public board.",
                  { name }
                )
          );
        }
      } catch (e) {
        flash("error", e.message);
      }
      res.backDontScroll();
    });
};

export default ChallengeReportTemplates;
